import React, {useState, useEffect, Fragment} from "react";
import {REFERRAL_LINK} from "../../default_informations/referral_link";
import {API_KEY} from "../../default_informations/api_key";
import {SlideDown} from "react-slidedown";
import 'react-slidedown/lib/slidedown.css'

function SidebarSliderItem({match}) {
    const refLink = REFERRAL_LINK;
    const apiKey = API_KEY;
    const [thisMatch, setThisMatch] = useState([]);

    useEffect(() => {
        fetch(`https://api.opendota.com/api/matches/${match.match_id}?api_key=${apiKey}`)
            .then(response => response.json())
            .then(result => setThisMatch(result));

        return () => {
            setThisMatch([]);
        }
    }, [match, apiKey]);

    let start_date = thisMatch.start_time;
    let start_match = new Date(start_date * 1000);
    let year = start_match.getFullYear();
    let month = start_match.getMonth() + 1;
    if (month < 10) month = `0${month}`;
    let date = start_match.getDate();
    if (date < 10) date = `0${date}`;
    let hours = start_match.getHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = start_match.getMinutes();
    if (minutes < 10) minutes = `0${minutes}`;
    let match_date = `${date}.${month}.${year}`;
    let match_time = `${hours}:${minutes}`;

    let date_now = `${new Date().getDate()}.${new Date().getMonth() + 1}.${new Date().getFullYear()}`;

    return (
        <div className="sidebar_card">
            <SlideDown>{
                thisMatch.length !== 0 ? (
                    <Fragment>
                        <div className="card-title">
                            {match.league_name}
                        </div>
                        <div className="players">
                            <div className="play first">
                                <p className="play-image">{
                                    thisMatch.radiant_team ? (
                                        <img
                                            src={Boolean(thisMatch.radiant_team.logo_url) ? thisMatch.radiant_team.logo_url : '../img/no_team_logo.png'}
                                            alt={match.radiant_name}
                                        />
                                    ) : null
                                }</p>
                                <p className="play-name">{match.radiant_name}</p>
                            </div>
                            <div className="play-live">
                                <b className="time">{match_time}</b>
                                {
                                    date_now === match_date ? (
                                        <span className="date">Сегодня</span>
                                    ) : (
                                        <span className="date">{match_date}</span>
                                    )
                                }
                            </div>
                            <div className="play second">
                                <p className="play-image">{
                                    thisMatch.dire_team ? (
                                        <img
                                            src={Boolean(thisMatch.dire_team.logo_url) ? thisMatch.dire_team.logo_url : '../img/no_team_logo.png'}
                                            alt={match.dire_name}
                                        />
                                    ) : null
                                }</p>
                                <p className="play-name">{match.dire_name}</p>
                            </div>
                        </div>
                        <p className="winner-title">Счёт</p>
                        <div className="coefficients">
                            <a className="coefficient first" href={refLink} rel="nofollow noopener noreferrer" target="_blank">{match.radiant_score}</a>
                            <p className="vs">vs</p>
                            <a className="coefficient second" href={refLink} rel="nofollow noopener noreferrer" target="_blank">{match.dire_score}</a>
                        </div>
                        <p className="card-link" />
                    </Fragment>
                ) : null
            }</SlideDown>
        </div>
    )
}

export default SidebarSliderItem;